import { useState, useEffect } from "react"
import { dashboardEvents, DASHBOARD_EVENTS } from "helpers/events/dashboard-events"

interface ArtifactPinLimitStatus {
  isLimitReached: boolean
  pinnedArtifactIds?: string[]
}

/**
 * Returns pin button status for a specific artifact.
 *
 * Subscribes to limit-status broadcasts from the Dashboard handler so the
 * pin button can show "Already on dashboard" pre-emptively without a click,
 * and stay disabled until the artifact is removed.
 */
export function usePinButtonStatus(artifactId: string): {
  isLimitReached: boolean
  isAlreadyOnDashboard: boolean
} {
  const [status, setStatus] = useState<ArtifactPinLimitStatus>({
    isLimitReached: false,
    pinnedArtifactIds: [],
  })

  useEffect(() => {
    return dashboardEvents.on<ArtifactPinLimitStatus>(
      DASHBOARD_EVENTS.ARTIFACT_PIN_LIMIT_STATUS,
      (payload) => {
        setStatus({
          isLimitReached: payload.isLimitReached ?? false,
          pinnedArtifactIds: payload.pinnedArtifactIds ?? [],
        })
      },
      { replay: true },
    )
  }, [])

  return {
    isLimitReached: status.isLimitReached,
    isAlreadyOnDashboard: status.pinnedArtifactIds?.includes(artifactId) ?? false,
  }
}
